import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-fill text-primary-500 text-2xl"></i>
              </div>
              <span className="font-heading text-xl font-bold text-foreground-50">星空影院</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              星空影院致力于为影迷提供最新、最热的电影资讯和在线观影推荐。与院线同步更新，让您第一时间掌握电影动态。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-primary-500 cursor-pointer whitespace-nowrap transition-colors">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-400 hover:text-primary-500 cursor-pointer whitespace-nowrap transition-colors">全部电影</Link></li>
              <li><Link to="/category/scifi" className="text-sm text-foreground-400 hover:text-primary-500 cursor-pointer whitespace-nowrap transition-colors">科幻电影</Link></li>
              <li><Link to="/category/action" className="text-sm text-foreground-400 hover:text-primary-500 cursor-pointer whitespace-nowrap transition-colors">动作电影</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-500 cursor-pointer whitespace-nowrap transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">电影分类</h4>
            <div className="flex flex-wrap gap-2">
              {categories.filter(c => c.slug !== 'all').slice(0, 8).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-3 py-1.5 rounded-full bg-background-200/50 border border-background-300/50 text-xs text-foreground-400 hover:text-foreground-50 hover:border-primary-500/50 cursor-pointer whitespace-nowrap transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">联系方式</h4>
            <ul className="flex flex-col gap-3 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-primary-500"></i>
                </div>
                contact@xingkongcinema.com
              </li>
              <li className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-primary-500"></i>
                </div>
                400-888-6666
              </li>
              <li className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line text-primary-500"></i>
                </div>
                北京市朝阳区星光大道88号
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 星空影院 XingKong Cinema. All Rights Reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-600">
            <a href="#" className="hover:text-foreground-300 cursor-pointer whitespace-nowrap transition-colors">隐私政策</a>
            <a href="#" className="hover:text-foreground-300 cursor-pointer whitespace-nowrap transition-colors">服务条款</a>
            <a href="#" className="hover:text-foreground-300 cursor-pointer whitespace-nowrap transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}